export const environment = {
    production: false,
    backend: '/api', // Put your backend here
    uri: {
        classifications:
            '/classification?resultCount=numberOfRecords&keyword=searchTerm&partner=name',
        classificationClassByProduct: '/classification/$productType/$id',
        states: '/state',
        products: '/#PARTNER#/product?classid=$classid$&stateid=$stateid$',
        validateZip: '/validateZip?Data.PostalCode=$search-term$',
        questions:
            '/#PARTNER#/questionsv2?classes=$classid$&products=$productid$',
        wcQuote: '/wcquote',
        wcUpdateQuote: '/wcupdatequote',
        semciWcQuote: '/semciwcquote',
        semciWcUpdateQuote: '/semciwcupdatequote',
        quote: '/#PARTNER#/quote',
        issue: '/#PARTNER#/issue',
        // stripe: '/charge',
        brainTree: '/payment',
        brainTreeToken: '/paymentAuth',
        saveQuote: '/savequote',
        addressLookUp:
            '/lookupAddress?Data.AddressLine1=$searchTerm$&Data.Country=$country$&Data.PostalCode=$postalCode$&MaxCandidates=$numRows$',
        retrieveQuote: '/retrievequote',
        updateQuote: '/#PARTNER#/updatequote',
        retrieveQuoteByEmail: '/getquotes?email=$emailAddress$',
        retrieveQuoteByQuote:
            '/getquotes?quoteNumber=$quoteNumber$&email=$emailAddress$&zipcode=$zipcode$',
        retrieveQuoteByProducerCode: '/getquotes?producerCd=$producerCd$',
        retrieveQuoteByQuoteKey: '/getquotes',
        downloadCOI: '/downloadcoi',
        quickQuote: '/quickquote',
        eligibilityQuestions: '/eligibilityqns',
        // SCI Endpoints
        sciDownloadCOI: '/scidownloadcoi',
        scigetquestions: '/sciquestionsv3',
        sciGetAmazonUWQ: '/briza/sciquestionsv3',
        sciQuote: '/#PARTNER#/sciquotev3',
        sciQuoteUpdate: '/#PARTNER#/sciupdatequotev3',
        scigetuwquestions: '/sciquestions/quotenumber',
        sciupdatequestions: '/sciupdatequestions',
        scirate: '/scirate',
        scirateupdate: '/scirateupdate',
        sciissue: '/#PARTNER#/sciissue',
        scioptionalcoverages: '/#PARTNER#/scioptionalcoverages',
        sciupdateoptionalcoverages: '/#PARTNER#/sciupdateoptionalcoverages',
        sciretrievequote: '/#PARTNER#/sciretrievequote',
        scisemciquote: '/#PARTNER#/scisemciquote',
        scigetsemciuwq: '/scisemciuwquestions',
        scisemciupdatequote: '/#PARTNER#/scisemciupdatequote',
        scisemciretrievequote: '/scisemciretrievequote',
        // scisemciretrievequote: '/#PARTNER#/scisemciretrievequote',
        storePdfData: '/quotes',
        getPdfData: '/quotes/:quoteId',
        createpdf: '/createpdf',
        pdfData: '/pdfData',
        wcretrievequote: '/wcretrievequote',
        semciwcretrievequote: '/semciwcretrievequote',
        partnerClassifications: '/classification/partner',
        wcjobtype: '/wcjobtype?digitalCode=$digitalCode&state=$state',
        wcjobtypecodes: '/wcjobtypecodes',
        wcentity: '/wcentity?entityCode=$entityCode&state=$state',
        wcofficertitle: '/wcofficertitle?entityCode=$entityCode',
        scicybergetuwq: '/scicyberuwquestions',
        scicyberproermgetuwq: '/scicyberproermuwquestions',
        billingdetermination: '/billingSystemDetermination',
        brainTreeMajescoToken: '/paymentAuthMajesco',
        scicyberQuote: '/scicyberquote',
        cyberQuoteUpdate: '/scicyberupdatequote',
        scicyberretrievequote: '/scicyberretrievequote',
        autoPaymentEnroll: '/recurring/enroll',
        downloadProposal: '/quotedocument',
        producerInfo: '/producerinfo',
        downloadPolicy: '/downloadpolicy',
        keywordSearch: '/keywordsearch',
        userProfile: '/userProfile',
        clientToken: '/clientToken',
        checkout: '/checkout',
        getReceipt: '/receipt?transactionId=$transactionId$',
        cisaQuoteSubmission: '/cisaquotesubmission',
    },
    paymentToken: 'https://payments.sandbox.braintree-api.com/graphql',
    coverhoundAmex:
        'https://commercial-s-chubb-uat.coverhound.us/business-insurance?source=310',
    coverhoundCSB:
        'https://commercial-s-chubb-uat.coverhound.us/business-insurance?source=313',
    displayReqResJson: true,
    // gtmTrackingId: 'GTM-5BNGF3F', // enable production gtmTrackingId ('GTM-5BNGF3F') after testing IRSessionId Cookie for dev environment
    gtmTrackingId: 'GTM-PWR7HTS', // disable dev gtmTrackingId ('GTM-PWR7HTS') after testing IRSessionId Cookie for dev environment
    digitalCxpClaimsUrl: 'https://claims-sit.chubbsmallbusiness.com/',
    appInsights: {
        instrumentationKey: 'e1a261eb-9a40-4549-bdbe-d624a64408ac',
    },
    baseUrl: 'https://wwwsit30.chubbsmallbusiness.com',
    servicePortalUrl: 'https://commercialservice-sit.chubb.com',
    appVersion: 1,
    isSciExcluded: false,
    chargeEnvironment: 'sandbox',
    disableInstallmentPay: 2,
    servicingURL: {
        registration:
            'https://commercialservice-sit.chubb.com/registration/activate',
        login: 'https://commercialservice-sit.chubb.com',
    },
    npsSurveyURL: 'https://www.google.com/',
    caWaiverURL:
        'https://stornau2sbsn001195902.blob.core.windows.net/csb-assets/pdf/california-waiver-of-wc-coverage-form.pdf',
    blobStorageBaseURL:
        'https://stornau2sbsn001195902.blob.core.windows.net/csb-assets',
    excludeWorkCompStates: ['PA'],
    partnerIds: [
        'prtnr001',
        'nawbo',
        'paypal',
        'pbn',
        'capitalone',
        'boldpenguin',
        'briza',
    ],
    cp1SparkCardURL: 'https://www.capitalone.com/Chubbinsurance/externalid=',
    isCp1SparkCashBannerIncluded: false,
    findAnAgentUrl:
        'https://www.chubb.com/us-en/business-insurance/find-an-agent.html',
    isUTCDate: false,
    isESTDayLight: false,
    csbAPPId: 'e313b08c-5c07-4414-8d55-2afe307d0cbe',
};
